
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[slug]/posts",
      function () {
        return require("private-next-pages/user/[slug]/posts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[slug]/posts"])
      });
    }
  